export default "__VITE_ASSET__BHP3pHBR__"